/**
 * Creates a deep mutable copy of an object to avoid readonly issues with GraphQL objects
 */
export function createMutableCopy<T>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => createMutableCopy(item)) as T;
  }

  const copy = {} as T;
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      copy[key] = createMutableCopy(obj[key]);
    }
  }

  return copy;
}
